import { Injectable, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService implements OnInit {
  public loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  constructor(private spinner: NgxSpinnerService) {

  }

  ngOnInit(): void {
  }

  show() {
    this.loading.next(true);
    this.spinner.show();
  }

  hide() {
    this.loading.next(false);
    this.spinner.hide();
  }
}
